import { AuthenticationResult } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Cloud as CloudIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import React, { type FormEvent, type FormEventHandler } from "react";
import { MESApiService } from "../../../services";
import { AuthContext } from "../../AuthContext";
import { loginRequest } from "./AzureADAuthConfig";

export const LoginWithAzureADForm = () => {
	const { saveUserData } = React.useContext(AuthContext);
	const { instance } = useMsal();
	const login: FormEventHandler = async (e: FormEvent) => {
		e.preventDefault();
		try {
			const result: AuthenticationResult =
				await instance.loginPopup(loginRequest);

			const api = new MESApiService();
			try {
				const loginResponse = await api.loginWithAzureAD(result.accessToken);
				saveUserData(loginResponse);
			} catch (e) {
				console.log(e);
			}
		} catch (e) {
			console.log({ e });
		}
	};

	return (
		<form onSubmit={login}>
			<Button
				fullWidth
				variant="contained"
				color="primary"
				sx={{
					backgroundColor: "#479DC4",
					color: "white",
					padding: (theme) => theme.spacing(1.2),
					fontWeight: 600,
					transition: "all 0.3s ease",
					"&:hover": {
						transform: "translateY(-2px)",
						boxShadow: (theme) => theme.shadows[4],
					},
				}}
				type="submit"
				startIcon={
					<CloudIcon
						sx={{
							marginRight: (theme) => theme.spacing(1),
						}}
					/>
				}
			>
				Login with Azure AD
			</Button>
		</form>
	);
};
